
import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../Navbar/Navbar';
import Footer from '../footer/Footer';

const InfluencerInformation = () => {
  const { t } = useTranslation();

  // CSS Değişkenleri
  const styles = {
    root: {
      "--bg": "#0f172a",          /* slate-900 */
      "--card": "#111827",        /* gray-900 */
      "--muted": "#94a3b8",       /* slate-400 */
      "--text": "#e5e7eb",        /* gray-200 */
      "--accent": "#22c55e",      /* green-500 */
      "--accent-2": "#60a5fa",    /* blue-400 */
      "--ring": "#1f2937",        /* gray-800 */
      "--border": "#1f2937",
      "--shadow": "0 10px 30px rgba(0,0,0,.35)",
      "--radius": "22px",
    },
    body: {
      margin: 0,
      background: "radial-gradient(1200px 600px at 10% -10%, rgba(34,197,94,.08), transparent), radial-gradient(1000px 600px at 110% 10%, rgba(96,165,250,.06), transparent), var(--bg)",
      color: "var(--text)",
      font: "16px/1.6 system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji'",
    },
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "32px 20px 80px"
    },
    hero: {
      display: "grid",
      gap: "18px",
      gridTemplateColumns: "1.2fr .8fr",
      alignItems: "center",
      marginTop: "12px"
    },
    badge: {
      display: "inline-block",
      padding: "8px 12px",
      border: "1px solid var(--border)",
      background: "rgba(255,255,255,.02)",
      borderRadius: "999px",
      color: "var(--muted)",
      fontWeight: 600,
      letterSpacing: ".3px"
    },
    h1: {
      margin: "6px 0 0",
      fontSize: "clamp(28px, 3.2vw, 42px)",
      lineHeight: 1.15
    },
    lead: {
      color: "var(--muted)"
    },
    heroCard: {
      background: "linear-gradient(180deg, rgba(255,255,255,.04), rgba(255,255,255,.02))",
      border: "1px solid var(--border)",
      padding: "22px",
      borderRadius: "var(--radius)",
      boxShadow: "var(--shadow)"
    },
    grid: {
      display: "grid",
      gap: "16px"
    },
    cols4: {
      gridTemplateColumns: "repeat(4, 1fr)"
    },
    cols3: {
      gridTemplateColumns: "repeat(3, 1fr)"
    },
    cols2: {
      gridTemplateColumns: "1fr 1fr",
      gap: "12px"
    },
    card: {
      background: "var(--card)",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)",
      padding: "18px 16px",
      boxShadow: "var(--shadow)"
    },
    label: {
      fontSize: "12px",
      letterSpacing: ".4px",
      color: "var(--muted)",
      textTransform: "uppercase"
    },
    value: {
      fontSize: "clamp(18px, 3vw, 26px)",
      fontWeight: 800,
      marginTop: "6px"
    },
    table: {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      overflow: "hidden",
      borderRadius: "16px",
      border: "1px solid var(--border)",
      background: "var(--card)",
      boxShadow: "var(--shadow)"
    },
    th: {
      background: "linear-gradient(180deg, rgba(96,165,250,.15), rgba(96,165,250,.06))",
      color: "#eaf2ff",
      textAlign: "left",
      padding: "14px 14px",
      fontSize: "13px",
      borderBottom: "1px solid var(--border)"
    },
    td: {
      padding: "14px",
      borderBottom: "1px solid var(--border)",
      color: "var(--text)"
    },
    bar: {
      height: "12px",
      background: "#0b1220",
      border: "1px solid var(--ring)",
      borderRadius: "999px",
      overflow: "hidden",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,.02)"
    },
    barStudent: {
      width: "60%",
      background: "linear-gradient(90deg, var(--accent), #16a34a)",
      display: "block",
      height: "100%"
    },
    chartCard: {
      background: "var(--card)",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)",
      padding: "16px",
      boxShadow: "var(--shadow)"
    },
    chartTitle: {
      margin: "0 0 8px",
      fontWeight: 700,
      letterSpacing: ".2px",
      color: "var(--text)"
    },
    hint: {
      color: "var(--muted)",
      fontSize: "13px"
    },
    cta: {
      display: "flex",
      gap: "12px",
      flexWrap: "wrap",
      marginTop: "14px"
    },
    btn: {
      appearance: "none",
      border: "none",
      borderRadius: "999px",
      padding: "12px 18px",
      fontWeight: 700,
      cursor: "pointer"
    },
    btnPrimary: {
      background: "linear-gradient(90deg, var(--accent), #16a34a)",
      color: "#04120a",
      boxShadow: "0 8px 20px rgba(34,197,94,.25)"
    },
    btnGhost: {
      background: "transparent",
      color: "var(--text)",
      border: "1px solid var(--border)"
    },
    footer: {
      marginTop: "42px",
      color: "var(--muted)",
      fontSize: "13px"
    },
    dark: {
      background: "#0f172a",
      color: "#e5e7eb"
    },
    // Diğer stiller
    sectionMargin: {
      marginTop: "28px"
    },
    sectionMarginSm: {
      marginTop: "22px"
    },
    h3: {
      margin: "0 0 10px"
    },
    h4Green: {
      margin: "0 0 8px",
      color: "var(--accent)"
    },
    h4Blue: {
      margin: "0 0 8px",
      color: "var(--accent-2)"
    },
    flexContainer: {
      display: "flex",
      gap: "12px",
      marginTop: "6px",
      color: "var(--muted)",
      fontSize: "13px"
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "16px",
      marginTop: "16px"
    },
    cardPadding: {
      padding: "16px"
    },
    cardTextSm: {
      margin: 0,
      fontSize: "14px"
    }
  };

  // Media queries için responsivlik JSX içinde conditional olarak yapılacak

  return (
    <>
      <div style={{...styles.root, ...styles.body}}>
        <div style={styles.container}>
          {/* HERO / Intro */}
          <section style={styles.hero}>
            <div>
              <span style={styles.badge}>Influencer Partner Programı</span>
              <h1 style={styles.h1}>
                Takipçine <span style={{color: "var(--accent)"}}>%40 indirim</span>, sana düzenli gelir! 🎯
              </h1>
              <p style={styles.lead}>
                Aşağıda işleyişi, örnek senaryoları ve anlaşılır grafiklerle kazanç potansiyelini özetledik. 
                Bu sayfayı doğrudan paylaşabilir ya da PDF olarak yazdırabilirsin.
              </p>
              <div style={styles.cta}>
                <button style={{...styles.btn, ...styles.btnPrimary}} className="pdf-yazdir-btn" onClick={() => window.print()}>
                  PDF / Yazdır
                </button>
                <a style={{...styles.btn, ...styles.btnGhost}} href="#detaylar">
                  Detayları Gör
                </a>
              </div>
            </div>
            <div style={styles.heroCard}>
              <div style={{...styles.grid, ...styles.cols2}}>
                <div style={styles.card}>
                  <div style={styles.label}>Liste Fiyatı</div>
                  <div style={styles.value}>1.000 TL</div>
                </div>
                <div style={styles.card}>
                  <div style={styles.label}>Öğrenci İndirimi</div>
                  <div style={styles.value}>%40</div>
                </div>
                <div style={styles.card}>
                  <div style={styles.label}>Öğrenci Öder</div>
                  <div style={styles.value}>600 TL</div>
                </div>
                <div style={styles.card}>
                  <div style={styles.label}>Influencer Kazancı (örnek)</div>
                  <div style={styles.value}>200 TL / satış</div>
                </div>
              </div>
              <p style={{...styles.hint, margin: "10px 2px 0"}}>
                * Rakamlar örnektir; nihai oran ve tutarlar anlaşmaya göre güncellenir.
              </p>
            </div>
          </section>

          {/* Açıklama */}
          <section id="detaylar" style={{...styles.sectionMargin}}>
            <div style={{...styles.card, padding: "22px"}}>
              <h2 style={{margin: "0 0 8px"}}>Nasıl İşliyor?</h2>
              <ol style={{margin: 0, paddingLeft: "18px"}}>
                <li>Sana aylık özel bir <b>kupon kodu</b> tanımlanır.</li>
                <li>Takipçilerin bu kodla kayıt olur ve <b>%40 indirimle</b> satın alır.</li>
                <li>Kodunla gerçekleşen her satış için <b>sabit ücret veya oran</b> üzerinden kazanç kazanırsın (bu örnekte 200 TL).</li>
                <li>Aylık raporla şeffaf <b>satış & kazanç dökümü</b> paylaşılır.</li>
              </ol>
            </div>
          </section>

          {/* Per-sale breakdown */}
          <section style={styles.sectionMarginSm} aria-labelledby="per-sale">
            <h3 id="per-sale" style={styles.h3}>Tek Satışın Fiyat Dağılımı (Örnek)</h3>
            <div style={{...styles.grid, ...styles.cols3}}>
              <div style={styles.card}>
                <div style={styles.label}>Liste Fiyatı</div>
                <div style={styles.value}>1.000 TL</div>
                <div style={styles.hint}>Eğitimin etiket fiyatı</div>
              </div>
              <div style={styles.card}>
                <div style={styles.label}>Öğrenci İndirimi</div>
                <div style={styles.value}>-400 TL</div>
                <div style={styles.hint}>%40 indirim uygulanır</div>
              </div>
              <div style={styles.card}>
                <div style={styles.label}>Öğrenci Öder</div>
                <div style={styles.value}>600 TL</div>
                <div style={styles.hint}>Kuponla indirimin ardından</div>
              </div>
            </div>
            <div style={{marginTop: "12px"}}>
              <div style={styles.label}>Görsel Dağılım</div>
              <div style={styles.bar} title="Öğrenci öder: 600 TL (60%), İndirim: 400 TL (40%)">
                <span style={styles.barStudent}></span>
              </div>
              <div style={styles.flexContainer}>
                <span>⬤ 600 TL – Öğrenci Ödemesi</span>
                <span>⬤ 400 TL – İndirim</span>
              </div>
            </div>
          </section>

          {/* Scenario table */}
          <section style={styles.sectionMargin}>
            <h3 style={styles.h3}>Aylık Satış Senaryoları</h3>
            <table style={styles.table} role="table" aria-label="Aylık Satış Senaryoları">
              <thead>
                <tr>
                  <th style={styles.th}>Kupon ile Gelen Satış Sayısı</th>
                  <th style={styles.th}>Öğrenci Ödeyeceği Toplam</th>
                  <th style={styles.th}>Influencer Toplam Kazanç (örnek)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.td}>10 öğrenci</td>
                  <td style={styles.td}>6.000 TL</td>
                  <td style={styles.td}>2.000 TL</td>
                </tr>
                <tr>
                  <td style={styles.td}>25 öğrenci</td>
                  <td style={styles.td}>15.000 TL</td>
                  <td style={styles.td}>5.000 TL</td>
                </tr>
                <tr>
                  <td style={styles.td}>50 öğrenci</td>
                  <td style={styles.td}>30.000 TL</td>
                  <td style={styles.td}>10.000 TL</td>
                </tr>
              </tbody>
            </table>
          </section>

          {/* SVG Bar Chart */}
          <section style={styles.sectionMarginSm}>
            <div style={{...styles.chartCard, ...styles.dark}}>
              <h3 style={{...styles.chartTitle, color: "#f8fafc"}}>Satış Sayısına Göre Toplam Kazanç (Örnek)</h3>
              <svg viewBox="0 0 640 340" width="100%" height="auto" role="img" aria-label="Satış sayısına göre toplam kazanç bar grafiği">
                {/* axes */}
                <rect x="48" y="20" width="1" height="280" fill="#64748b"/>
                <rect x="48" y="300" width="540" height="1" fill="#64748b"/>
                {/* y labels */}
                <g fill="#cbd5e1" fontSize="12">
                  <text x="0" y="305">0</text>
                  <text x="0" y="255">2.500</text>
                  <text x="0" y="205">5.000</text>
                  <text x="0" y="155">7.500</text>
                  <text x="0" y="105">10.000</text>
                </g>
                {/* bars */}
                <g>
                  <rect x="120" y="248" width="80" height="52" rx="8" fill="url(#g1)"/>
                  <text x="160" y="238" textAnchor="middle" fill="#e5e7eb" fontWeight="700">2.000 TL</text>
                  <text x="160" y="320" textAnchor="middle" fill="#8aa0b5">10 satış</text>
                </g>
                <g>
                  <rect x="280" y="170" width="80" height="130" rx="8" fill="url(#g1)"/>
                  <text x="320" y="160" textAnchor="middle" fill="#e5e7eb" fontWeight="700">5.000 TL</text>
                  <text x="320" y="320" textAnchor="middle" fill="#8aa0b5">25 satış</text>
                </g>
                <g>
                  <rect x="440" y="40" width="80" height="260" rx="8" fill="url(#g1)"/>
                  <text x="480" y="30" textAnchor="middle" fill="#e5e7eb" fontWeight="700">10.000 TL</text>
                  <text x="480" y="320" textAnchor="middle" fill="#8aa0b5">50 satış</text>
                </g>

                {/* gradient fill */}
                <defs>
                  <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#22c55e"/>
                    <stop offset="100%" stopColor="#16a34a"/>
                  </linearGradient>
                </defs>
              </svg>
              <p style={{...styles.hint, color: "#cbd5e1"}}>
                Not: Grafik, örnek oranlara (200 TL / satış) göre ölçeklenmiştir.
              </p>
            </div>
          </section>

          {/* Satış Raporlama Paneli */}
          <section style={{marginTop: "26px"}}>
            <div style={styles.chartCard}>
              <h3 style={styles.chartTitle}>Influencer Satış Rapor Paneli 📊</h3>
              <p style={{margin: "10px 0", color: "var(--text)"}}>
                Programımıza katıldığınızda, aşağıdaki özelliklere sahip kişisel satış raporlama panelinize erişim sağlayacaksınız:
              </p>
              <div style={styles.cardGrid}>
                <div style={{...styles.card, ...styles.cardPadding}}>
                  <h4 style={styles.h4Green}>📈 Anlık Satış Takibi</h4>
                  <p style={styles.cardTextSm}>
                    Kupon kodunuzla gerçekleşen tüm satışları gerçek zamanlı olarak görüntüleyin. Her satış anında bildirim alın.
                  </p>
                </div>
                <div style={{...styles.card, ...styles.cardPadding}}>
                  <h4 style={styles.h4Blue}>💰 Kazanç Özeti</h4>
                  <p style={styles.cardTextSm}>
                    Toplam ve dönemsel kazanç bilgilerinizi, ödeme durumlarını ve gelecek ödemeleri takip edin.
                  </p>
                </div>
                <div style={{...styles.card, ...styles.cardPadding}}>
                  <h4 style={styles.h4Green}>📊 Detaylı Analitikler</h4>
                  <p style={styles.cardTextSm}>
                    Hangi paylaşımlarınızın daha çok satış getirdiğini analiz edin, takipçi demografinize göre performans raporları alın.
                  </p>
                </div>
                <div style={{...styles.card, ...styles.cardPadding}}>
                  <h4 style={styles.h4Blue}>📱 Mobil Uyumlu</h4>
                  <p style={styles.cardTextSm}>
                    Panel tamamen mobil uyumludur, satışlarınızı ve kazancınızı istediğiniz zaman, istediğiniz yerden kontrol edebilirsiniz.
                  </p>
                </div>
              </div>
              <p style={{...styles.hint, marginTop: "16px"}}>
                *Raporlama panelinize program başlangıcında özel giriş bilgilerinizle erişebileceksiniz.
              </p>
            </div>
          </section>

          {/* CTA */}
          <section style={{marginTop: "26px"}}>
            <div style={{...styles.card, padding: "22px"}}>
              <h3 style={{margin: "0 0 6px"}}>Birlikte çalışalım 💬</h3>
              <p style={styles.lead}>
                İlgin varsa, sana özel kupon kodunu oluşturalım ve ilk paylaşım taslaklarını birlikte planlayalım.
              </p>
              <div style={styles.cta}>
                <a style={{...styles.btn, ...styles.btnPrimary}} href="#">Programa Katıl</a>
                <a style={{...styles.btn, ...styles.btnGhost}} href="#">Detay İste</a>
              </div>
            </div>
          </section>

          <footer style={styles.footer}>
            Bu sayfa sadece örnek amaçlıdır. Tutarlar ve oranlar işbirliğine göre güncellenebilir.
          </footer>
        </div>
      </div>
    </>
  );
};

export default InfluencerInformation;
